import React from 'react';
import moment from 'moment';
import HttpClient from 'services/HttpClient';
import CollapseContainer from '../components/Base';
import _ from 'lodash';
import {withRouter} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import {TOPIC_TYPES} from 'constants/topicTypes';

const TOPICS_REQUEST = '/api/v1/tutorials';
const TRACKER = '/api/v1/search_tutorials';

@withRouter
@inject('examPrepHeaderStore')
@inject('topicsStore')
@inject('userStore')
@observer
export default class extends React.Component {

  state = {tutorials: [], topic: {}};

  componentWillMount(){
    const {match, examPrepHeaderStore: {setTopic}, userStore} = this.props;
    const isExamPrep = userStore.isExamPrepUser();
    const id = match.params.id;

    if (isExamPrep && id) {
      new HttpClient().get(`${TOPICS_REQUEST}/${id}`).then(data => {
        const topic = data.body.data.tutorial;
        const params = `?reimbursement_type[]=${TOPIC_TYPES[topic.tutorial_type]}`

        setTopic(topic);

        new HttpClient().get(`${TRACKER}${params}`).then(data => {
          if(data.body.data && !_.isEmpty(data.body.data.tutorials)) {
            const { tutorials } = data.body.data;

            this.setState({tutorials, topic});
          }
        })
      });
    } else {
      const params = `?reimbursement_type[]=${0}`

      new HttpClient().get(`${TRACKER}${params}`).then(data => {
        if(data.body.data && !_.isEmpty(data.body.data.tutorials)) {
          const { tutorials } = data.body.data;

          this.setState({tutorials});
        }
      })
    }
  }

  renderHeader = (type) => {
    switch(type) {
      case 'cct':
        return 'Please complete the quiz to receive your certificate of completion of the Prescription Revision MICGP CCT exam prep course. To pass the quiz, you must answer 8 out of 10 questions correctly. Submit the certificate as part of the reimbursement process.';
      case 'ckt':
        return 'Please complete the quizzes below to receive your certificate of completion of the Prescription Revision MICGP CKT exam prep course. Submit this certificate as part of the reimbursement process.';
      default:
        return 'Please complete the quizzes below to receive your certificate of completion of the Prescription Revision course. Submit this certificate as part of the reimbursement process.';
    }
  }

  render() {
    const {topic} = this.state;
    const completed = this.state.tutorials.filter(tutorial => tutorial.completed);
    const isAllCompleted = this.state.tutorials.length === completed.length;
    const token = localStorage.getItem('token');

    return (
      <div className="tracker">
        <div className="container-fluid tracker-container">
          {/* <div className="tracker-head">
            <div className="tracker-period tracker-head-holder">
              <div className="tracker-head-caption">
                {`CPD Year: May ${startAt} - Apr ${endAt}`}
              </div>
            </div>
            <div className="tracker-activity tracker-head-holder">
              <div className="tracker-head-caption align-right">Total activity:</div>
              <div className="tracker-head-info">
                <span>CPD Points: {this.state.cpd_points} Ext</span>
              </div>
            </div>
          </div> */}
          {/* {_.keys(this.state.revisions).map( (key) => */}
          {this.state.tutorials.length > 0 &&
            <div className="tracker-content">
              <div className="tracker-content-holder">
                <h3
                  style={{
                    textAlign: 'center',
                    fontWeight: 'bold',
                    marginBottom: '25px',
                  }}
                >
                  {this.renderHeader(topic.tutorial_type)}
                </h3>
                <CollapseContainer elements={this.state.tutorials}/>
              </div>
              {isAllCompleted ?
                <div
                  style={{display: 'flex', justifyContent: 'center'}}
                >
                  <a
                    className="btn blue rounded update-btn"
                    style={{
                      margin: '40px',
                      backgroundColor: 'white',
                      border: '1px solid #28b5f4',
                      color: '#28b5f4'
                    }} // http://192.81.220.169/api/v1/pdfs/${topic.id}?token=${token} : https://prescriptionrevision.com/api/v1/pdfs/${topic.id}?token=${token}
                    href={topic.id ? `https://prescriptionrevision.com/api/v1/pdfs/${topic.id}?token=${token}` : `https://prescriptionrevision.com/api/v1/pdfs/generate?token=${token}`} // http://192.81.220.169/api/v1/pdfs/generate?token=${token} https://prescriptionrevision.com/api/v1/pdfs/generate?token=${token}
                    target='_blank'
                  >
                    {topic.tutorial_type !== 'cct' ? 'View CPD Cert' : 'VIEW CCT CERT'}
                  </a>
                </div>
                : null
              }
            </div>
          }
          {/* )

          } */}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/reimbursed/containers/Reimbursed.js